import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from "@angular/router";
import { AuthenticationService } from './_services/authentication.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        public auth: AuthenticationService,
        private _router: Router
    ) { }

    // getFreshToken() {

    // }
    // localStorage.getItem('token')

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return Observable.fromPromise(this.auth.getToken())
            .mergeMap((token) => {
                if (token) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `${token}`
                        }
                    });
                }
                return next.handle(request)
                    .do(event => {
                        if (event instanceof HttpResponse) {
                            console.log(event);
                        }
                    })
                    .catch(err => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status === 401) {
                                // redirect user to login
                                this._router.navigate(['/login']);
                                // this.auth.login();
                            }
                        }
                        console.error('Caught error', err);
                        return Observable.throw(err);
                    });

                // return next.handle(request)
                //     .do(event => {
                //         console.debug('Interceptor')
                //         if (event instanceof HttpResponse) {
                //             console.log(event);
                //         }
                //         else
                //         // success
                //     })
                //     .catch(err => {
                //         // error
                //         console.error('Caught error', err);
                //         if (err instanceof HttpErrorResponse) {
                //             if (err.status === 401) {
                //                 // redirect user to login
                //                 this._router.navigate(['/login']);
                //                 // this.auth.login();
                //             }
                //         }
                //     });
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/token.interceptor.ts